import { render, staticRenderFns } from "./editPackage.vue?vue&type=template&id=f9b8474c&scoped=true"
import script from "./editPackage.vue?vue&type=script&lang=js"
export * from "./editPackage.vue?vue&type=script&lang=js"
import style0 from "./editPackage.vue?vue&type=style&index=0&id=f9b8474c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b8474c",
  null
  
)

export default component.exports